import MobileHeader from '../../components/mobile/MobileHeader';
import MobileWishForm from '../../components/mobile/MobileWishForm';

const MobileWishFormPage = () => {
  return (
    <div>
      <MobileHeader title="發布許願" onBack={() => window.history.back()} />
      <MobileWishForm />
    </div>
  );
};

export default MobileWishFormPage;
